/**
 * @file: context.tsx
 *
 * The chat contact-list context. Provided by `ChatContactsProvider`
 * (see `./provider`) and read via `useChatContacts()`.
 */

import { createContext, useContext } from 'react';
import { ChatContactsStore } from './types';

export const ChatContactsContext = createContext<ChatContactsStore | null>(
  null,
);

export function useChatContacts(): ChatContactsStore {
  const ctx = useContext(ChatContactsContext);
  if (!ctx) {
    throw new Error(
      'useChatContacts must be used within a ChatContactsProvider',
    );
  }
  return ctx;
}
